import * as React from 'react';

function SvgFilter(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.897 9.2H3.889v5.2h2.008v11.593a.7.7 0 101.4 0V14.4h1.592V9.2H7.297V3.84a.7.7 0 00-1.4 0V9.2zM15.7 17h1.9v5.2h-1.997a.697.697 0 01.097.356v3.437a.7.7 0 11-1.4 0v-3.437c0-.13.035-.252.097-.356H12.6V17h1.7V3.84a.7.7 0 111.4 0V17zM5.289 10.6V13h2.2v-2.4h-2.2zm20.6-1.4h-1.786V3.84a.7.7 0 10-1.4 0V9.2h-1.814v5.2h1.814v11.593a.7.7 0 101.4 0V14.4h1.786V9.2zm-1.4 3.8h-2.2v-2.4h2.2V13zm-10.49 7.8h2.2v-2.4H14v2.4z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgFilter;
